__turbopack_context__.v({
  "className": "merriweather_97ee736b-module__d5dRSq__className",
  "variable": "merriweather_97ee736b-module__d5dRSq__variable",
});
